import { Outlet, createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Suspense } from 'react';
import { PageError, PageSkeleton } from '@/components/Skeleton';
import { TweaksProvider } from '@/lib/tweaks';
import { AuthProvider } from '@/lib/AuthProvider';
import { UserCompletionProvider } from '@/lib/userCompletion';
import { AppError } from '@/lib/errors';

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: ({ error, reset }) => (
    <PageError error={error} onRetry={reset} onHome={() => (window.location.href = '/')} />
  ),
  notFoundComponent: () => (
    <PageError
      error={new AppError('Trang bạn yêu cầu không tồn tại.', { title: 'Không tìm thấy trang' })}
      onHome={() => (window.location.href = '/')}
    />
  ),
});

function RootComponent() {
  return (
    <AuthProvider>
      <UserCompletionProvider>
        <TweaksProvider>
          <Suspense fallback={<PageSkeleton />}>
            <Outlet />
          </Suspense>
          {import.meta.env.DEV && (
            <Suspense fallback={null}>
              <TanStackRouterDevtools position="bottom-right" />
            </Suspense>
          )}
        </TweaksProvider>
      </UserCompletionProvider>
    </AuthProvider>
  );
}
